import { isEmpty } from 'lodash'

export function schemaReducer(state = {
    REPORTS : null,
    AGENTS : null,
    QUOTATIONS : null,
    SAV : null,
    ALL : null,
},{
    type,
    payload
}){
    switch(type){
        case "GET_SCHEMAS":
            let list = Object.assign({}, state)
            list.ALL = isEmpty(list.ALL) ? payload : Object.assign(list.ALL, payload)
            list.AGENTS = payload
            
            return list
            
        case "GET_REPORT_SCHEMAS":
            let list2 = Object.assign({}, state)
            list2.ALL = isEmpty(list2.ALL) ? payload : Object.assign(list2.ALL, payload)
            list2.REPORTS = payload

            return list2
        
        case "GET_QUOTATION_SCHEMAS":
            let list3 = Object.assign({}, state)
            list3.ALL = isEmpty(list3.ALL) ? payload : Object.assign(list3.ALL, payload)
            list3.QUOTATIONS = payload

            return list3

        case "GET_SAV_SCHEMAS":
            let list4 = Object.assign({}, state)
            list4.ALL = isEmpty(list4.ALL) ? payload : Object.assign(list4.ALL, payload)
            list4.SAV = payload

            return list4
        
        default:
            return state;
    }
}